export default __webpack_public_path__ + "static/media/about2.c43153d3.jpg";